import { render, staticRenderFns } from "./sidebarService.vue?vue&type=template&id=26b33193&scoped=true&"
import script from "./sidebarService.vue?vue&type=script&lang=js&"
export * from "./sidebarService.vue?vue&type=script&lang=js&"
import style0 from "./sidebarService.vue?vue&type=style&index=0&id=26b33193&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b33193",
  null
  
)

export default component.exports